module.exports = __webpack_public_path__ + "static/media/background.c31a4700.jpg";